<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>合同模板列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="模板编号">
          <el-input v-model="listQuery.templateId" placeholder="请输入模板名称编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="模板名称">
          <el-input v-model="listQuery.templateName" placeholder="请输入模板名称" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
          <el-button icon="el-icon-plus" type="primary" plan @click="handleCreateTemplate">新增模板</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column prop="templateId" label="模板Id" fixed="left"></el-table-column>
        <el-table-column prop="templateName" label="模板名称" fixed="left"></el-table-column>
        <el-table-column prop="contractPrefix" label="合同编号前缀"></el-table-column>
        <el-table-column prop="template_state" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.templateState == 0">启用</el-tag>
            <el-tag v-if="scope.row.templateState == 1" type="danger">停用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="needReview" label="是否需要审核" align="center">
          <template slot-scope="scope">
            <el-tag type="success">{{
              scope.row.needReview | filterNeedView
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="signOneType" label="第一个签署人" align="center">
          <template slot-scope="scope">
            {{scope.row.signOneType|filterSignType1}}
          </template>
        </el-table-column>
        <el-table-column prop="signTwoType" label="第二个签署人" align="center">
          <template slot-scope="scope">
            {{scope.row.signTwoType|filterSignType2}}
          </template>
        </el-table-column>
        <el-table-column prop="signThreeType" label="第三个签署人" align="center">
          <template slot-scope="scope">
            {{scope.row.signThreeType|filterSignType2}}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="creatTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column>

        <el-table-column prop label="操作" fixed="right" width="150px" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleTemplateEdit(scope.row)">模板配置</el-button>
            <el-button v-if="scope.row.templateState==0" type="text" @click="deleteTemplate(scope.row,1)">停用</el-button>
            <el-button v-if="scope.row.templateState==1" type="text" @click="deleteTemplate(scope.row,0)">启用</el-button>
            <el-button type="text" @click="showTemplateFild(scope.row)">查看模板字段</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
    </el-card>

    <!-- 新增合同模板 -->
    <el-dialog title="新增合同模板" :visible.sync="VisibleCreateDialog" width="1050px" :close-on-click-modal="false" center>
      <div style="margin-bottom:20px">
        <el-steps :active="step" finish-status="success" align-center>
          <el-step title="上传模板" description="PDF合同文件" />
          <el-step title="模板编辑" description="易签宝编辑模板" />
          <el-step title="配置签名" description="签名参数配置" />
          <el-step title="字段配置" description="模板字段配置" />
        </el-steps>
      </div>

      <!-- 模板上传 -->
      <el-form :model="createTemplateForm" ref="createTemplateForm" label-width="120px" style="height:400px" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="模板名称" prop="templateName">
              <el-input v-model="createTemplateForm.templateName" placeholder clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否审核" label-width="100px" prop="needReview">
              <el-select style="width:100%" v-model="createTemplateForm.needReview" clearable placeholder="是否需要审核" filterable>
                <el-option v-for="(keyType,index) in templateNeedReview" :key="index" :label="keyType.name" :value="keyType.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
<!--          <el-col :span="6">-->
<!--            <el-form-item label="关联业务表" label-width="100px" prop="templateBuzSqlId">-->
<!--              <el-select style="width:100%" v-model="createTemplateForm.templateBuzSqlId" @change="changeBuzSql" clearable placeholder="关联业务表" filterable>-->
<!--                <el-option v-for="(item,index) in buzList" :key="index" :label="item.buzName" :value="item.id"></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
        </el-row>

        <!-- 第一步 上传模板文件pdf -->
        <el-form-item v-if="step==1" label="上传模板">
          <el-upload class="upload-demo" action="123" :limit="1" accept=".pdf" :file-list="fileListA" list-type="picture" :on-change="handleOnChangeA" :auto-upload="false">
            <el-button size="small" type="primary">点击选择PDF模板</el-button>
          </el-upload>
        </el-form-item>

        <!--第二步  去易签宝编辑合同模板 -->
        <div v-if="step==2" style="height:360px;display: flex;justify-content: center;align-items: center;">
          <div>
            <div style="font-size:28px">模板提交成功,点击此处”<a :href="createTemplateForm.fileUrl" target="_blank" style="color:red">编辑模板</a>"，到易签宝平台编辑模板</div>
            <div style="font-size:15px;display: block;text-align: center;"><span>模板编辑完成后，点击”模板编辑完成“按钮；如果无需编辑模板 可以点击“跳过模板设置“</span></div>
          </div>
        </div>

        <!-- 第三步 模板签字信息配置 -->
        <div v-if="step==3">
          <div style="font-size:18px;color:black;margin:10px">
            <i class="el-icon-edit" style="color: #606266;font-size:18px;color:black" />
            <span class="font-small">模板签字信息配置</span>
          </div>
          <div class='table-layout'>
            <el-row>
              <el-col :span="8" class="table-cell-title">第一签署人</el-col>
              <el-col :span="8" class="table-cell-title">第二签署人</el-col>
              <el-col :span="8" class="table-cell-title">第三签署人</el-col>
            </el-row>
            <el-row>
              <el-col :span="2" class="table-cell-title">签署人</el-col>
              <el-col :span="4" class="table-cell-title">签署位置</el-col>
              <el-col :span="2" class="table-cell-title">是否自动签署</el-col>
              <el-col :span="2" class="table-cell-title">签署人</el-col>
              <el-col :span="4" class="table-cell-title">签署位置</el-col>
              <el-col :span="2" class="table-cell-title">是否自动签署</el-col>
              <el-col :span="4" class="table-cell-title">签署人</el-col>
              <el-col :span="4" class="table-cell-title">签署位置</el-col>
            </el-row>

            <el-row>
              <el-col :span="2" class="table-cell">
                <el-select style="width:80px" v-model="createTemplateForm.signOneType" clearable placeholder="第一签署人" filterable>
                  <el-option v-for="(keyType,index) in templateSignOneType" :key="index" :label="keyType.name" :value="keyType.id"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4" class="table-cell">
                <el-select ref="signOnePosition" style="width:150px" v-model="createTemplateForm.signOnePosition" clearable placeholder="第一签署位置" filterable>
                  <el-option v-for="(keyType,index) in signList" :key="index" :label="keyType.fieldName" :value="keyType.id"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" class="table-cell">
                <el-select style="width:80px" v-model="createTemplateForm.isOneAutoSign" clearable placeholder="是否自动签署" filterable>
                  <el-option v-for="(keyType,index) in isAutoSignList" :key="index" :label="keyType.name" :value="keyType.id"></el-option>
                </el-select>
              </el-col>

              <el-col :span="2" class="table-cell">
                <el-select style="width:80px" v-model="createTemplateForm.signTwoType" clearable placeholder="第二签署人" filterable>
                  <el-option v-for="(keyType,index) in templateSignOneType" :key="index" :label="keyType.name" :value="keyType.id"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4" class="table-cell">
                <el-select style="width:150px" v-model="createTemplateForm.signTwoPosition" clearable placeholder="第二签署位置" filterable>
                  <el-option v-for="(keyType,index) in signList" :key="index" :label="keyType.fieldName" :value="keyType.id"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" class="table-cell">
                <el-select style="width:80px" v-model="createTemplateForm.isTwoAutoSign" clearable placeholder="是否自动签署" filterable>
                  <el-option v-for="(keyType,index) in isAutoSignList" :key="index" :label="keyType.name" :value="keyType.id"></el-option>
                </el-select>
              </el-col>

              <el-col :span="4" class="table-cell">
                <el-select style="width:150px" v-model="createTemplateForm.signThreeType" clearable placeholder="第三签署人" filterable>
                  <el-option v-for="(keyType,index) in templateSignOneType" :key="index" :label="keyType.name" :value="keyType.id"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4" class="table-cell">
                <el-select style="width:150px" v-model="createTemplateForm.signThreePosition" clearable placeholder="第三签署位置" filterable>
                  <el-option v-for="(keyType,index) in signList" :key="index" :label="keyType.fieldName" :value="keyType.id"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 第四步 模板字段配置 -->
        <div v-if="step==4">
          <div style="font-size:18px;color:black;margin:10px">
            <i class="el-icon-setting" style="color: #606266;font-size:18px;color:black" />
            <span class="font-small">模板字段配置(共{{templateFiledlList.length}}个字段)</span>
          </div>
          <div class="table-layout">
            <el-table :data="templateFiledlList" border style="width: 100%;" height="300" size="mini" class="table">
              <el-table-column prop="fieldName" label="字段名称"  align="center" fixed="left">
                <template slot-scope="scope">
                  <el-tag>{{scope.row.fieldName}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="fieldName" label="字段英文名" align="center" fixed="left">
                <template slot-scope="scope">
                  <el-tag>{{scope.row.fieldKey}}</el-tag>
                </template>
              </el-table-column>

              <el-table-column prop="sort" label="字段序号" :sortable="true"  align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.sort" type="number" placeholder clearable></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="type" label="字段类型" align="center" >
                <template slot-scope="scope">
                  <el-select size="small" v-model="scope.row.type" clearable placeholder="请选择类型" filterable>
                    <el-option v-for="(keyType,index) in templateKeyType" :key="index" :label="keyType.name" :value="keyType.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>

<!--              <el-table-column prop="type" label="对应业务字段" align="center">
                <template slot-scope="scope">
                  <el-select style="width:150px" size="small" v-model="scope.row.fieldBuzKey" clearable placeholder="请选择业务字段" filterable>
                    <el-option v-for="(item,index) in buzSqlId" :key="index" :label="item.key" :value="item.key"></el-option>
                  </el-select>
                </template>
              </el-table-column>-->

<!--              <el-table-column prop="type" label="对应帐号类型" align="center">
                <template slot-scope="scope">
                  <el-select style="width:150px" v-model="scope.row.signAccountType" clearable placeholder="请选择对应帐号类型" filterable>
                    <el-option v-for="(keyType,index) in signAccountList" :key="index" :label="keyType.dictKey" :value="keyType.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column prop="myextJsonList" label="类型值" align="center">
                <template slot-scope="scope">
                  <el-cascader style="width:100%" v-model="scope.row.myextJsonList" :props="{
                  multiple: true,
                  value: 'id',
                  label: 'name',
                }" :options="templateDictValue" expand-trigger="hover" clearable @change="handleDictChange(scope.row)" />
                </template>
              </el-table-column>-->

              <el-table-column prop="mustFill" label="是否必填" align="center">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.mustFill">必填</el-checkbox>
                </template>
              </el-table-column>
            </el-table>

          </div>

        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="VisibleCreateDialog=false">取消</el-button>
        <el-button type="primary" v-if="step==1" icon="el-icon-upload" @click="handleStep1()">上传模板</el-button>
        <el-button type="primary" v-if="step>2" icon="el-icon-caret-left" @click="handlePreStep()">上一步</el-button>
        <el-button type="primary" v-if="step==2" icon="el-icon-setting" @click="handleStep2()">模板编辑完成</el-button>
        <el-button type="warning" v-if="step==2" icon="el-icon-arrow-right" @click="handleStep21()">跳过模板设置</el-button>
        <el-button type="success" v-if="step==3" icon="el-icon-edit" @click="handleStep3()">签字配置完成</el-button>
        <el-button type="success" v-if="step==4" icon="el-icon-circle-check" @click="handleStep4()">完成合同模板配置</el-button>
      </span>
    </el-dialog>

    <el-dialog title="模板字段详情" :visible.sync="templateFiledDialog" width="1050px" :close-on-click-modal="false" center>
      <!-- 列表数据 -->
      <el-table :data="templateFiledlList2" border style="width: 100%" class="table">
        <el-table-column prop="fieldName" label="字段名"></el-table-column>
        <el-table-column prop="fieldKey" label="字段英文名"></el-table-column>
<!--        { id: 1, name: "单行文本" },
        { id: 2, name: "数字" },
        { id: 3, name: "日期" },
        { id: 6, name: "签约区" },
        { id: 11, name: "图" },
        { id: 20, name: "合同编号" },
        { id: 30, name: "下拉选择" },
        { id: 31, name: "复选框" },
        { id: 32, name: "身份证" },
        { id: 33, name: "手机号" }-->
        <el-table-column prop="type" label="字段类型">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type == 1">单行文本</el-tag>
            <el-tag v-if="scope.row.type == 2" >数字</el-tag>
            <el-tag v-if="scope.row.type == 3" >日期</el-tag>
            <el-tag v-if="scope.row.type == 6" >签约区</el-tag>
            <el-tag v-if="scope.row.type == 11" >图</el-tag>
            <el-tag v-if="scope.row.type == 20" >合同编号</el-tag>
            <el-tag v-if="scope.row.type == 30">下拉选择</el-tag>
            <el-tag v-if="scope.row.type == 31" >复选框</el-tag>
            <el-tag v-if="scope.row.type == 32" >身份证</el-tag>
            <el-tag v-if="scope.row.type == 33" >手机号</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="mustFill" label="是否必填">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.mustFill == 0">否</el-tag>
            <el-tag v-if="scope.row.mustFill == 1">是</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>
<script>
import moment from "moment";
import ElementUI from "element-ui";
import Pagination from "@/components/common/Pagination";
import contractApi from "@/script/api/contractConfigApi";
//import globalData from "@/components/common/globaldata/global.data.vue";
import commutil from "@/components/common/globaldata/commutil.data.vue";
/**
 * 流程
 * 1,上传pdf模板到易签宝
 * 2,获取上传pdf的编辑地址 编辑模板信息
 * 3,完成第二步编辑后 将易签宝字段更新到实体表
 * 4,编辑模板字段信息
 * 5,完成编辑
 *
 */

export default {
  components: { Pagination },
  filters: {
    filterNeedView(value) {
      if (value == 1) return "要审核(归档)";
      if (value == 2) return "不审核(自动归档)";
   /*   if (value == 3) return "不审核(归档)";
      if (value == 4) return "不审核自动盖章(归档)";*/
      return "未设定";
    },
    filterSignType1(value) {
      if (value == 1) return "机构";
      if (value == 2) return "个人";
/*      if (value == 3) return "客户";
      if (value == 4) return "主机构盖章";*/
      return "未设定";
    },
    filterSignType2(value) {
      if (value == 1) return "机构";
      if (value == 2) return "个人";
    /*  if (value == 3) return "客户";
      if (value == 4) return "其他";*/
      return "未设定";
    },
  },
  data() {
    return {
      templateNeedReview: commutil.templateNeedReview,
      templateKeyType: commutil.templateKeyType,
      templateDictType: commutil.templateDictType,
      templateSignOneType: commutil.templateSignOneType,
      templateSignTwoType: commutil.templateSignTwoType,
      templateDictValue: [], //字典值--为escard控件渲染值
      templateDictData: [], //字典值--原始值
      buzList: "", //关联的业务表
      buzSqlId: "", //关联业务表的字段
      signList: [], //签字信息
      signAccountList: [], //sign_account_type
      stationList: [],
      listData: [],
      step: 1, //模板新增的步骤 目前分2步 上传pdf文件，然后配置参数
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        templateId: "",
        templateName: "",
      },
      fileListA: [],
      rules: {
        templateName: [
          { required: true, message: "请填写模板名称", trigger: "blur" },
        ],
        needReview: [
          { required: true, message: "请选择审核模式", trigger: "blur" },
        ],
        templateBuzSqlId: [
          { required: true, message: "请选择关联业务表", trigger: "blur" },
        ],
      },
      VisibleCreateDialog: false,
      createTemplateForm: {
        id:"",
        templateId: "",
        templateName: "",
        signOneType: "",
        signOnePosition: "",
        signTwoType: "",
        signTwoPosition: "",
        signThreeType: "",
        signThreePosition: "",
        file: "",
        fileUrl: "",
        isOneAutoSign:"",
        isTwoAutoSign:""
      },
      templateFiledlList: [], //获取所有模板字段
      isAutoSignList:commutil.isAutoSignList,
      templateFiledlList2:[],
      templateFiledDialog: false,

    };
  },
  created() {
    this.querySearch();
    //this.getBuzSqlList();
    //this.getTemplateAccountConfig();
  },
  methods: {
    //查询
    querySearch() {
      let temp = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        templateId: this.listQuery.templateId,
        templateName: this.listQuery.templateName,
      };

      contractApi
        .$axiosGetTempLatePage(temp)
        .then((res) => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleCreateTemplate() {
      //新增模板
      this.step = 1;
      this.VisibleCreateDialog = true;
      this.createTemplateForm = { id: "",contractPrefix:"jz" };
    },
    handleTemplateEdit(row) {
      //第二步 pdf上传完成后 获取编辑地址 开始编辑模板
      this.VisibleCreateDialog = true;
      this.createTemplateForm = Object.assign({}, row);
      if (
        this.createTemplateForm.contractPrefix == null ||
        this.createTemplateForm.contractPrefix == ""
      )
        this.createTemplateForm.contractPrefix = "jz";

      //表示未上传模板
      if (
        this.createTemplateForm.templateFileUrl == null ||
        this.createTemplateForm.templateFileUrl == ""
      ) {
        this.step = 1;
      } else this.getTemplateEditUrl(row.templateId);
    },
    handleStep1() {
      if (
        this.createTemplateForm.file == null ||
        this.createTemplateForm.file == ""
      ) {
        this.$message.warning("请选择模板文件");
        return;
      }

      this.$refs["createTemplateForm"].validate((valid) => {
        if (valid) {
          let temp = new FormData();
          temp.append("templateName", this.createTemplateForm.templateName);
          temp.append("file", this.createTemplateForm.file);
          contractApi.$axiosTemplateAddFile(temp).then((res) => {
            if (res.data.errno == 0) {
              this.createTemplateForm.templateId = res.data.data.templateId;
              this.createTemplateForm.templateFileUrl =
                res.data.data.templateFileUrl;
              this.getTemplateEditUrl(this.createTemplateForm.templateId);
              this.$message.success("模板上传成功");
              console.log(this.createTemplateForm);
            }
          });
        }
      });
    },
    handleStep2() {
      //第二步 将模板已经修改的模板字段信息,更新到mysql表中
      this.$refs["createTemplateForm"].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "配置获取中,请稍等...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.syncTemplateField(this.createTemplateForm.templateId);
        }
      });

    },
    handleStep21() {
      //第二步  如果没有修改模板 可以直接跳过模板设置 直接配置字段
      this.$refs["createTemplateForm"].validate((valid) => {
        if (valid) {
          this.getTemplateField(this.createTemplateForm.templateId);
        }
      });
      console.log("测试==="+this.createTemplateForm.signTwoPosition)
      this.createTemplateForm.signTwoPosition=this.createTemplateForm.signTwoPosition
    },
    handleStep3() {
      //第三步 签字区域信息 配置完成
      this.step = 4;
    },
    handleStep4() {
      //最后一步 保存模板
      contractApi
        .$axiosSaveOrUpdateTemplate(this.createTemplateForm)
        .then((res) => {
          //处理mytextjsonList
          let templateFiledData = JSON.parse(
            JSON.stringify(this.templateFiledlList)
          );
          templateFiledData.forEach((filed) => {
            let dicts = [];
            if (
              filed.myextJsonList != null &&
              filed.myextJsonList != "" &&
              filed.myextJsonList.length > 0
            ) {
              filed.myextJsonList.forEach((item) => {
                this.templateDictData.forEach((dict) => {
                  if (item[1] == dict.id) {
                    dicts.push(dict);
                  }
                });
              });
              filed.myextJsonList = dicts;
            } else {
              filed.myextJsonList = [];
              filed.myextJson = "";
            }
          });
          console.info(templateFiledData);
          contractApi
            .$axiosBatchUpdateFieldConfig(templateFiledData)
            .then((res) => {
              this.$message.success("合同模板保存成功");
              this.VisibleCreateDialog = false;
              //location.reload();
              this.querySearch();
            })
            .catch((res) => {
              this.$message.warning(res.data.errmsg);
            });
        });
    },
    handleDictChange(row) {
      //scope.row.dictValue
      //字段自定义属性
      //需要封装成此格式：[{key:"身份证",val:"√",escape_val:"CRED_PSN_CH_IDCARD"},{},{}]
      console.info(row);
    },
    getTemplateEditUrl(templateId) {
      contractApi
        .$axiosGetTemplateEditUrl({ templateId: templateId })
        .then((res) => {
          this.createTemplateForm.fileUrl = res.data.data;
          if (
            this.createTemplateForm.id == null ||
            this.createTemplateForm.id == ""
          ) {
            contractApi
              .$axiosSaveOrUpdateTemplate(this.createTemplateForm)
              .then((res) => {
                if(res.data.errno==0) {
                  console.log("idcscscsc============>"+res.data.data)
                  this.createTemplateForm.id = res.data.data;
                  //console.log(this.createTemplateForm)
                  this.step = 2;
                } else {
                  this.$message.error("模板创建失败");
                }
              });
          } else {
            this.step = 2;
          }
        });
    },
    getTemplateField(templateId) {
      contractApi
        .$axiosGetTemplateField({ templateId: templateId })
        .then((res) => {
          if (res.data.errno == 0) {
            this.templateFiledlList = res.data.data;
            this.step = 3;
            //取出type=6（签署位置的信息）
            var signList = [];
            this.templateFiledlList.forEach((item, index) => {
              if (item.type == 6) signList.push(item);
              //排序
              if (item.sort == null || item.sort == "") item.sort = index + 1;
              //构造el-cascader绑定值
              if(item.myextJson!=''){
                let exts = JSON.parse(item.myextJson);
                let myextJsonList = [];
                exts.forEach((ext) => {
                  myextJsonList.push([ext.type, ext.id]);
                });
                item.myextJsonList = myextJsonList;
              }
            });

            this.signList = signList;
            this.$forceUpdate();

           /* console.info(this.templateFiledlList);
            console.info(this.signList);
            for (let i = 0; i < this.signList.length; i++) {
              console.log(this.signList[i].id+"cs"+this.signList[i].fieldName);
              if(this.createTemplateForm.signTwoPosition==this.signList[i].id){
                this.createTemplateForm.signTwoPosition=this.signList[i].fieldName
              }
            }*/
          }
        });
    },
    getTemplateAccountConfig() {
      //获取模板字典值
      contractApi.$axiosGetTemplateAccountConfig().then((res) => {
        this.templateDictData = res.data.data;
        //封装字典值 为2级选择框
        this.templateDictType.forEach((item) => {
          if (item.id != 1) {
            this.templateDictValue.push({
              id: item.id,
              name: item.name,
              children: [],
            });
          }
        });

        res.data.data.forEach((item) => {
          if (item.type == 1) {
            this.signAccountList.push(item);
          }
          this.templateDictValue.forEach((dict) => {
            if (dict.id == item.type) {
              dict.children.push({
                id: item.id,
                name: item.dictKey,
                value: item.dictVal,
              });
            }
          });
        });
        // console.info(this.templateDictType);
      });
    },
    getBuzSqlList() {
      if (this.buzList.length != 0) return;
      //获取关联的业务表
      contractApi.$axiosGetTemplateBuzSqlList().then((res) => {
        this.buzList = res.data.data;
      });
    },
    /*getBuzSqlIdList(sqlId) {
      contractApi.$axiosGetTempLateRelaSql({ sqlId: sqlId }).then((res) => {
        this.buzSqlId = res.data.data;
      });
    },*/
    /*changeBuzSql(value) {
      this.getBuzSqlIdList(value);
    },*/
    syncTemplateField(templateId) {
      //模板编辑完成后 调用此接口 更新模板字段信息
      contractApi
        .$axiosSyncTemplateField({ templateId: templateId })
        .then((res) => {
           this.getTemplateField(this.createTemplateForm.templateId);
        });
    },

    handlePreStep() {
      //上一步
      this.step = this.step - 1;
    },
    handleOnChangeA(file, fileListA) {
      console.log("文件大小：", file.raw.size / 1024 / 1024 + "M");
      if (file.name.indexOf(".pdf") < 0) {
        this.$message.warning("请选择PDF文件");
        return;
      }
      //console.log(file);
      if (file.raw) {
        this.createTemplateForm.file = file.raw;
      }
    },
    //查看模板字段
    showTemplateFild(row){
      contractApi
        .$axiosGetTemplateField({ templateId: row.templateId })
        .then((res) => {
          if (res.data.errno == 0) {
            this.templateFiledDialog=true;
            this.templateFiledlList2 = res.data.data;
          }
        })
    },
    deleteTemplate(row,state){
      contractApi
        .$ajaxdeleteTemplate({ id: row.id,state:state })
        .then((res) => {
          if (res.data.errno == 0) {
              this.$message.success("操作成功");
              //location.reload();
              this.querySearch();
          }
        })
    }
  },
};
</script>
<style scoped>
.table-layout {
  margin-top: 10px;
  border-left: 1px solid #dcdfe6;
  border-top: 1px solid #dcdfe6;
}

.table-cell {
  line-height: 19px;
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 1px;
  font-size: 13px;
  color: #606266;
  text-align: center;
  white-space: pre-wrap;
  /* overflow: hidden; */
  height: 36px;
}

.table-cell-title {
  height: 36px;
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 8px;
  background: #f2f6fc;
  text-align: center;
  font-size: 13px;
  color: #303133;
  font-weight: 600;
}

.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
</style>
